import { Box, Center, Flex, Text, useTheme } from '@chakra-ui/react';
import { useToken } from '@chakra-ui/system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FA_ICONS } from '../../icons';

type MatchedExpertPillProps = {
  icon?: string;
  iconComponent?: React.ReactNode;
  text: string;
};

const COLORS = ['purple.600', 'blue.600', 'green.600', 'brown.600', 'cyan.800', 'pink.800'];
export const MatchedExpertPill: React.FC<MatchedExpertPillProps> = (props) => {
  const { icon, text, iconComponent } = props;
  const theme = useTheme();
  if ((!icon && !iconComponent) || !text) return <></>;
  return (
    <Flex
      padding="4px"
      border="1px solid"
      borderColor="scheme.borderPrimary"
      borderRadius="8px"
      align="center"
      mr="8px"
      mt="8px"
      boxShadow="0px 2px 4px rgba(0, 0, 0, 0.06)"
    >
      <Center borderRadius="4px" background={!icon ? 'green.100' : COLORS[text.length % 6]} h="20px" w="20px">
        {iconComponent ? (
          iconComponent
        ) : (
          <FontAwesomeIcon
            icon={FA_ICONS[icon as keyof typeof FA_ICONS]}
            width="12px"
            height="12px"
            style={{ color: theme.colors.scheme.backgroundPrimary }}
          />
        )}
      </Center>
      <Text variant="label-medium" color="scheme.contentPrimary" ml="6px" mr="4px">
        {text}
      </Text>
    </Flex>
  );
};
